import styled from 'styled-components';
export var PlotContainer = styled.div.withConfig({
  displayName: "style__PlotContainer",
  componentId: "k20ym-0"
})(["color:white;height:650px;width:100%;"]);
export var SpinnerBox = styled.div.withConfig({
  displayName: "style__SpinnerBox",
  componentId: "k20ym-1"
})(["color:red;position:relative;margin:auto;float:left;top:50%;left:50%;transform:translate(-50%,-50%);"]);
export var ControlsContainer = styled.div.withConfig({
  displayName: "style__ControlsContainer",
  componentId: "k20ym-2"
})(["margin-left:20px;margin-right:35px;height:25%;top:0;"]);
export var ItemContainer = styled.div.withConfig({
  displayName: "style__ItemContainer",
  componentId: "k20ym-3"
})(["width:100%;height:100%;margin-top:60px;display:table-cell;"]);
export var Label = styled.div.withConfig({
  displayName: "style__Label",
  componentId: "k20ym-4"
})(["width:100%;display:flex;align-content:flex-start;vertical-align:middle;font-style:normal;font-weight:bold;height:35px;line-height:35px;font-size:14px;color:#000;text-align:left;"]);
export var Item = styled.div.withConfig({
  displayName: "style__Item",
  componentId: "k20ym-5"
})(["height:35px;box-sizing:border-box;display:flex;justify-content:center;margin:auto;width:100%;margin-left:0;"]);
export var Panel = styled.div.withConfig({
  displayName: "style__Panel",
  componentId: "k20ym-6"
})(["position:relative;height:", ";padding-top:20px;padding-left:10px;overflow-x:hidden;overflow-y:auto;background-color:#e9eded;border-top-left-radius:5px;border-top-right-radius:5px;"], function (props) {
  return props.height ? props.height : '650px';
});
export var CheckboxContainer = styled.div.withConfig({
  displayName: "style__CheckboxContainer",
  componentId: "k20ym-7"
})(["order:0;width:40px;margin-left:5px;height:100%;display:flex;align-items:center;"]);
export var Checkbox = styled.div.withConfig({
  displayName: "style__Checkbox",
  componentId: "k20ym-8"
})(["width:10%;margin:auto;"]);
export var SectionContainer = styled.div.withConfig({
  displayName: "style__SectionContainer",
  componentId: "k20ym-9"
})(["position:relative;width:100%;min-width:100%;max-height:", ";min-height:", ";height:", ";color:#303030;margin-top:15px;margin-bottom:30px;padding-right:15px;padding-left:20px;"], function (props) {
  return props.height ? props.height : '715px';
}, function (props) {
  return props.height ? props.height : '715px';
}, function (props) {
  return props.height ? props.height : '715px';
});
export var RangeContainer = styled.div.withConfig({
  displayName: "style__RangeContainer",
  componentId: "k20ym-10"
})(["color:\xB7#000;display:inline-block;"]);
export var PanelContainer = styled.div.withConfig({
  displayName: "style__PanelContainer",
  componentId: "k20ym-11"
})(["display:flex;justify-content:flex-start;"]);
export var ButtonContainer = styled.div.withConfig({
  displayName: "style__ButtonContainer",
  componentId: "k20ym-12"
})(["margin-top:12px;display:inline-block;order:0;margin-left:35px;"]);
export var PanelBody = styled.div.withConfig({
  displayName: "style__PanelBody",
  componentId: "k20ym-13"
})(["width:95%;padding:10px;"]);
export var LegendContainer = styled.div.withConfig({
  displayName: "style__LegendContainer",
  componentId: "k20ym-14"
})(["min-height:295px;height:295px;max-height:75%;overflow-y:scroll;overflow-x:hidden;"]);
export var Space = styled.div.withConfig({
  displayName: "style__Space",
  componentId: "k20ym-15"
})(["min-height:", ";height:", ";max-height:", ";"], function (props) {
  return props.heigth ? props.heigth : '450px';
}, function (props) {
  return props.heigth ? props.heigth : '450px';
}, function (props) {
  return props.heigth ? props.heigth : '450px';
});
export var ClearPlotButtonContainer = styled.button.withConfig({
  displayName: "style__ClearPlotButtonContainer",
  componentId: "k20ym-16"
})(["position:absolute;bottom:0;left:0;right:0;height:40px;width:100%;border-bottom-left-radius:5px;border-bottom-right-radius:5px;border:none;outline:none;background-color:#c4c4bf;color:#fff;&:hover{background-color:#7b7a77;}"]);
export var Tag = styled.div.withConfig({
  displayName: "style__Tag",
  componentId: "k20ym-17"
})(["height:100%;width:100%;line-height:40px;text-align:center;"]);
export var ClearIcon = styled.img.withConfig({
  displayName: "style__ClearIcon",
  componentId: "k20ym-18"
})(["height:19px;margin-right:6px;"]);